<script>
    import {Link} from 'svelte-routing';
    import Button from "./Button.svelte";
</script>
<nav>

    <div class="logo">
        <Link to="/">
            GS
        </Link>
    </div>
    <div class="links">
        <Link to="/lobby">
            <Button text="Lobby"/>
        </Link>
        <Link to="/admin">
            <Button text="Admin"/>
        </Link>
    </div>

</nav>
<span class="nav-margin"></span>
<style>
    nav {
        width: 100%;
        height: var(--header-height);
        background: var(--dark-background);
        padding: 0 10px;

        position: fixed;
        top: 0;
        z-index: 1000;

        display: flex;
        justify-content: space-between;
        align-items: center;

        border-bottom: 2px solid #232323;
    }

    .links {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .logo {
        font-family: 'Pacifico', cursive;
        font-size: 32px;
        width: 60px;
    }

    .nav-margin {
        display: block;
        height: var(--header-height);
    }
</style>
